
import { atom } from "recoil"

// 공인 인증서 가져오기
export const showCertiBringLayerState = atom({
	key: "showCertiBringLayerState",
	default: false
})